<template>
  <div>
    <h5 v-if="title != null">
      {{ title }}
      <span v-if="modified" class="ml-1 text-muted" @click="$emit('reset')"><i class="fas fa-times-circle"></i></span>
      <span class="ml-1 text-muted small" @click="$emit('clear')">(clear)</span>
    </h5>
    <div v-for="(option, index) in options" v-bind:key="index" :class="'form-check mb-2' + (inline ? ' form-check-inline' : '')">
      <input class="form-check-input" v-model="selected" @change="$emit('updated', selected)" type="checkbox" :checked="isChecked(option.value)" :name="safeName" :id="safeId(index)" :value="option.value">
      <label class="form-check-label ml-1 mr-2" :for="safeId(index)" :title="option.tooltip != null ? option.tooltip : option.label">{{ option.label == null ? option.value : option.label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "InlineCheckboxOptions",
  
  data() {
    return {
      selected: []
    }
  },
  
  props: {
    inline: Boolean,
    title: String,
    name: String,
    options: Array,
    values: Array,
    modified: Boolean
  },
  
  mounted() {
    this.selected = this.values;
  },

  watch:{
    values: {
      deep: false,
      handler: function (val, oldVal) {
        this.selected = val;
      }
    }
  },

  methods: {
    safeId(index) {
      return this.safeName + '-' + index;
    },
    
    isChecked(value) {
      return this.selected.find(v => v === value);
    }
  },
  
  computed: {
    isModified() {
      return JSON.stringify(this.values) !== JSON.stringify(this.originalValues);
    },
    
    safeName() {
      return this.name + "Checkboxes";
    }
  }
}
</script>
